export const en = {
  language: 'Language',
  serverName: 'TVU MediaHub',
  view: 'View',
  gridL: 'Grid layout',
  listL: 'List layout',
  Source: 'Source',
  createS: 'Last Created',
  activeS: 'Active First',
  editS: 'Last Edited ',
  alpS: 'Alphanumeric ',
  Relational: 'Relational Sorting',
  source: 'Source',
  sourceType: 'Source Type',
  filter: 'Filter',
  search: 'Search',
  clearA: 'Clear all',
  gridPack: 'Grid-Pack',
  tvuPack: 'TVU Pack',
  ext: 'Ext',
  tag: 'Tag',
  inputType: 'Input type',
  Project: 'Project',
  liveS: 'Live First ',
  name: 'Name',
  xy: 'XY Grid Monitor',
  managePay: 'Manage Payment',
  planPay: 'Plan Payment',
  planM: 'Plan management',
  preview: 'Preview',
  record: 'Record',
  recordNotSupported: 'Recording is not currently supported',
  noDesc: 'No description',
  notLive: 'Not live with any project',
  noTag: 'No tag',
  projectIna: 'Project inactive',
  scope: 'Scope',
  Scope: 'Scope',
  stop: 'Stop',
  stopping: 'Stopping',
  sourceName: 'Source Name',
  sourceNameEmpty: 'Please enter a source name',
  outputProject: 'Output Project',
  to: 'to',
  status: 'Status',
  all: 'All',
  live: 'Live',
  ended: 'Ended',
  startTime: 'Start Time(Local time)',
  stopTime: 'Stop Time(Local time)',
  duration: 'Duration',
  health: 'Status/Health',
  total: 'Total',
  page: 'Page',
  goto: 'Go to',
  ok: 'OK',
  clear: 'Clear',
  outputType: 'Output Type',
  quickSetup: 'Quick Setup',
  tvuDevice: 'TVU Device',
  zoom: 'Zoom Meeting',
  tiktok: 'Tiktok',
  enterU: 'Enter URL',
  entUText: 'Enter the URL of the video stream you want to assign to this source',
  eg: 'eg. ',
  disableSaveTip: 'Cannot edit/delete while live. Stop the live session to make changes.',
  disableEditTip: 'You have no permission to edit this source.',
  save: 'Save',
  cancel: 'Cancel',
  apply: 'Apply',
  avail: 'Available',
  occ: 'Occupied',
  peeIdOrName: 'PeerID or Name',
  projectIdOrName: 'ProjectID or Name',
  type: 'Type',
  deviceName: 'Device Name',
  deviceType: 'Device Type',
  devicePID: 'Device PID',
  bit: 'Bitrate',
  fps: 'FPS',
  resolution: 'Resolution',
  created: 'Created',
  mediaAnalyzerLite: 'Media Analyzer Lite',
  mediaAnalyzer: 'Media Analyzer',
  videoTitle: 'Video',
  audioTitle: 'Audio',
  maNoData: 'No Data',
  lat: 'Latency',
  server: 'Server',
  domainT: 'Domain Name/IP',
  desc: 'Description',
  location: 'Location',
  personal: 'Personal',
  group: 'Group',
  pushTo: 'Push to MediaHub',
  pullTo: 'Pull into MediaHub',
  streamU: 'Stream URL',
  streamK: 'Stream Key',
  generate: 'Generate',
  urlTip: 'URL will display the value in micro seconds',
  moreO: 'More Options',
  more: 'More',
  passphrase: 'Passphrase',
  passphraseTip: 'Enter 10-79 characters',
  manual: 'Manual',
  discovery: 'Discovery Server',
  noServer: 'No Server',
  hostMName: 'Host Machine Name',
  streamName: 'Stream Name',
  invitationParser: 'Invitation Parser',
  meetingId: 'Meeting ID',
  meetingCode: 'Meeting Passcode',
  meetingCodeT: 'Please enter correct Meeting Passcode',
  boot: 'Recording Bot Name',
  bootPlaceholder: 'Enter Recording Bot Name',
  bootT: 'Name of the recording bot that joins Zoom meetings.<br/>Customize it to help your team recognize and approve<br/>the bot more easily.',
  partyMsg: 'You are not in white list in this party, please contact host',
  activeSpearker: 'Active Speaker',
  specificSpeaker: 'Specific Speaker',
  spearker: 'Speaker',
  spearkerT: 'Enter Speaker Name',
  dwAgent: 'Download Agent Installer',
  selectN: 'Select Node',
  commandT: 'Please run the following command with root or sudo',
  toIns: 'To install',
  toUnins: 'To uninstall',
  nodeName: 'Box Nick Name',
  nodePlaceholder: 'Select Box Nick Name',
  sdiPort: 'Port',
  sdiReference: 'SDI Port reference',
  sdiDuplex: 'SDI Input/Output is not available while the Agent is in Full Duplex mode.{ele}Please <a>switch to Half Duplex mode</a> and try again.',
  tvuRes: 'TVU-Hosted',
  resource: 'Resources',
  region: 'Region',
  adConfig: 'Advanced Configuration',
  otDetail: 'Other Details',
  ownRes: 'Bring Your Own Resources',
  agentTips1: 'Seamlessly integrate your own resources to host live video routing',
  agentTips2: 'workflows in TVU MediaHub via a lightweight software agent. ',
  agentTips3: 'Access your SDI Signals by installing TVU Agent',
  destination: 'Destination',
  Destination: 'Destination',
  // previewPanelV2 三种 panelType（folder/destination/source）对应的 actions / status 段标题 [Claude Code]
  folderActions: 'Folder Actions',
  destinationActions: 'Destination Actions',
  sourceActions: 'Source Actions',
  destinationStatus: 'Destination Status',
  sourceStatus: 'Source Status',
  encodeProfile: 'Encoding Profile',
  newDest: 'New Destination',
  destName: 'Destination Name',
  chartTips: 'Less than 100 characters',
  alpSing: 'Alphabetical Sorting',
  createSing: 'Creation Time Sorting',
  liveOnly: 'Live Only',
  streamIndex: 'Stream Index',
  pushMedia: 'Push from MediaHub',
  pullMedia: 'Pull from MediaHub',
  publishAcc: 'Publish to your social media account',
  KS: 'Kuaishou',
  others: 'Others',
  other: 'Other',
  encodeManage: 'Encoding Profile Management',
  encodeName: 'Encoding Profile Name',
  operation: 'Operation',
  inUse: 'In Use',
  edit: 'Edit',
  duplicate: 'Duplicate',
  delete: 'Delete',
  remove: 'Remove', // 移除按钮 title 文案 [Claude Code]
  profileName: 'Profile Name',
  videoEncoder: 'Video Encoder',
  format: 'Format',
  advanced: 'Advanced',
  yes: 'Yes',
  no: 'No',
  codec: 'Codec',
  scale: 'Scale',
  level: 'Level',
  profile: 'Profile',
  audioEncode: 'Audio Encoder',
  sampleRate: 'Sample Rate',
  noData: 'No Data',
  deleteTip: 'Do you want to delete XX profile?',
  confirm: 'Confirm',
  deleteSuccess: 'Delete success',
  add: 'Add',
  passthrough: 'Follow Input',
  outputs: 'Outputs',
  micoService: 'Microservices',
  colorCorrection: 'Color Correction',
  useResTips: 'You are currently using your own resources',
  share: 'Share',
  access: 'Access',
  Admin: 'Admin',
  admin: 'Admin',
  accessT: 'Access email of your group members',
  selectSubG: 'Select your subgroup',
  owner: 'Owner',
  done: 'Done',
  state: 'State',
  takeLive: 'Take Live: These users/groups can take the source live',
  recordings: "Record: These users/groups can access the source's event recordings",
  livePreview: 'Live preview',
  noUsers: 'No users',
  deleteConfirm: 'Are you sure you want to delete {sourceName} source?',
  permissionTip: "You don't have permission to remove the assignment of this device from this object",
  noPort: 'No SDI Port',
  hlsMulti: 'HLS Multi Rendition',
  multiProfile: 'Multi Encoding Profile',
  copy: 'Copy',
  dnsTip: 'If your DNS cannot resolve the original URL, you can use the following IP-based URL instead. Please note that IP URLs will change each time the task is restarted',
  correctTip: 'Adjusts video colors to improve image quality. Note: This is a paid feature.',
  fecRow: 'FEC rows',
  fecCol: 'FEC columns',
  multiChart: 'Rows multiplied by columns should be less than or equal to 100',
  rows: 'rows',
  cols: 'cols',
  select: 'Select',
  deleCom: 'Delete Confirm',
  deleteProject: 'Are you sure you want to delete {projectName}? It can not be recovered.',
  stopDestinaton: 'Are you sure you want to deactivate this destination?',
  // folder 卡片停流确认文案：对象是 folder 而非单个 destination [Claude Code]
  stopFolder: 'Are you sure you want to deactivate this folder?',
  stopDestinatonWithName: 'Are you sure you want to deactivate {objectName} destination?',
  deleteLiveProject: 'Are you sure you want to delete {projectName}? {projectName} is on live, delete would take effect after stopping live.',
  deletePreviewSource: 'The source is currently preview. Stop preview first, then delete source',
  deleteLiveSource: 'Are you sure you want to delete {sourceName}? You are living this source, Delete will shut down the live',
  deleteRecordSource: 'Are you sure you want to delete {sourceName}? You are recording this source, Delete will stop recording',
  transportMode: 'Transport Mode',
  faildOutput: 'Fail to parse URL, please enter a correct URL or try to select an output type',
  faildSourceType: 'Fail to parse URL, please enter a correct URL or try to select a source type',
  trialRemain: 'Trial Remaining',
  freeTip: 'Your free trial of TVU Media Hub will EXPIRE at 14/8/2024 23',
  sourceCreateSuc: 'Object created<br/><a id="view-source-object-click">View Object</a>',
  sourceCreateFail: 'Object created failed',
  projectCreatedSuc: 'Object created<br/><a id="view-project-object-click">View Object</a>',
  projectCreatedFail: 'Project created failed',
  backupSource: 'Backup Source',
  primary: 'Primary',
  backup: 'Backup',
  default: 'Default',
  Apply: 'Apply',
  applySave: 'Apply and Save',
  resConfig: 'Default Resource Configuration',
  previewShutdown: 'Idle Preview Shutdown Without Live for 15min',
  shutdownTask: 'This is a Group Wide Configuration',
  previewRecovery: 'Idle Preview Recovery',
  recoverReVisting: 'Recover preview tasks that are shutdown due to idle upon re-visiting the MediaHub page',
  tvuAgent: 'Self-Hosted Deployment',
  agentDownloadTips: 'To Deploy MediaHub on your own computing resources, <a href="{url}" target="_blank">Find out more in TVU Home.</a>',
  boxPool: 'Box Pool',
  boxPoolPlaceholder: 'Please select a Agent Box Pool',
  manageBoxPool: 'To manage your resources, go to <a href="{url}" target="_blank">TVU Home</a>',
  manageStaticIP: '<a href="{url}" target="_blank">Static IP Management</a>',
  optional: 'Optional',
  startProject: 'Outputs Starting',
  startPreview: 'Starting preview',
  copyUrl: 'Copy source url',
  liveWith: 'Live with <span class="liveName" title="Live with{name}">{name}</span>',
  thumbnail: 'Thumbnail',
  projectName: 'Project Name',
  description: 'Description',
  cloudBox: 'Cloud Box',
  phsicalBox: 'Physical Box',
  scopeT: 'The Scope function is disabled for this project. Restart project with the function enabled to access.',
  broadcastR: 'Broadcast Router',
  warining: 'Warnings',
  streamFailed: 'streaming failed',
  readOnlyWhileStreaming: 'This item cannot be edited while the source is streaming.',
  occur: 'occur',
  newEvent: 'New Event',
  event: 'Event',
  eventName: 'Event name',
  startTimes: 'Start Time',
  endTimes: 'End Time',
  selectDT: 'Select date and time',
  notRepeat: 'Does not repeat',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  annually: 'Annually',
  MtoF: 'Every weekday (Monday to Friday)',
  custom: 'Custom',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  January: 'January',
  Febuary: 'Febuary',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  August: 'August',
  September: 'September',
  October: 'October',
  November: 'November',
  December: 'December',
  destType: 'Destination Type',
  encoderFile: 'Encoder Profile',
  videoBit: 'Video Bitrate',
  audioBit: 'Audio Bitrate',
  dropFs: 'Dropped Frames',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  agenda: 'Agenda',
  emptyEvent: 'No events yet',
  recordingTask: 'Recording Task Already Started, please wait',
  recording: 'Recording',
  recordConfig: 'Recording Config',
  speechTran: 'Speech transcription',
  recordStandard: 'Standard ingest pricing may apply. Please contact your TVU sales representative for more details.',
  bucket: 'Bucket',
  bucketT: 'Please enter Bucket',
  facialDetection: 'Facial detection',
  config: 'Config',
  recordTooltip: 'Recording: Enables the recording of the source <br /> for the duration of the event.',
  start: 'Start',
  createNewFP: 'Create new filter profile',
  saveAs: 'Save as',
  events: 'Events',
  sources: 'Sources',
  online: 'Online',
  onlineNoInput: 'Online with no input',
  offline: 'Offline',
  tvuMediaSource: 'TVU MediaSource',
  tagFilter: 'Enter tag to filter',
  manageTag: 'Manage Tags',
  Event: 'Event',
  tags: 'Tags',
  tagName: 'Tag Name',
  Personal: 'Personal',
  Group: 'Group',
  noEventPermission: "You don't have permission to edit the event",
  downloadTip: 'Download source schedule',
  importTip: 'Import source schedule',
  importS: 'import success',
  saveMapS: 'save mapping success',
  importSchedule: 'Import source event schedule',
  fieldM: 'Field Mapping',
  templateError: 'get template error',
  profileExiste: 'The profile has been existed',
  saveFail: 'Save fail',
  tagListError: 'get taglist error',
  saveS: 'Save success',
  saveF: 'Save failed',
  copyS: 'Copy successful.',
  selectTag: 'Please select tag',
  payError: 'Failed to open the Manage Payment portal',
  enterBucket: 'Please enter Bucket',
  enterRegion: 'Please enter Region',
  noPermissionDT: 'You do not have permission to delete the tags.',
  unlinkS: 'Unlink success',
  unlinkF: 'Unlink failed',
  linkDevice: 'Please select a link device',
  assignObj: 'A device has been assigned from the object',
  validDomain: 'Please enter the valid Domain Name',
  isspInvalid: 'The issp url is invalid',
  selectServer: 'Please select the server',
  completeUrl: 'Please enter the complete url',
  correctUrl: 'Please enter the correct url',
  invalidKey: 'The stream key is invalid',
  domainChar: 'The domain contains 1 to 18 characters',
  avaKey: 'Please enter the available key',
  deviceFaildTry: 'Device activation failed. Please try again later',
  sdiInactive: 'The SDI Node is inactive',
  selectNodePort: 'Please select the SDI of Node and Port',
  selectResourceUrl: 'Please enter the resource URL',
  inputSourceName: 'Please enter the source name',
  selectRegion: 'Please select region',
  selectPbox: 'Please select physical box',
  addFail: 'Add fail',
  srtUrlInvaild: 'The srt url is invalid',
  operateS: 'Operate success!',
  deleteS: 'Delete successfully',
  inputProfile: 'Please input profile name',
  selectOutputA: 'Please select output account',
  notSupport: 'The browser not support copy',
  copyFromPro: 'Object {projectName} info copy successfully.',
  startWait: 'The current pipeline is starting up, please wait',
  liveWithS: 'The current source {sourceObjectName} is live with this project',
  notSupportSDI: 'The cloud Box does not support SDI source',
  noAvailableDest: 'No Valid Output Destination Available.',
  pcheck: 'Please check',
  checkPConfig: 'Output Project Configuration',
  switchQuick: 'You’re switching too quickly. Please wait a second and try again.',
  StopS: 'Stop successfully',
  selectBackup: 'Please select a backup source',
  primaryNoEx: 'The primary source is not exist',
  copyFromObj: 'Object {tangibleName} info copy successfully.',
  stopFirst: 'This source is already live with {livePeerName}, please stop it first.',
  notLiveOffline: 'This source is offline, cannot live now.',
  recordingS: 'Recording Task Already Started, please wait',
  editSu: 'Edit successfully',
  picUpload: 'Please select a picture to upload',
  picTooLarge: 'The picture is too large, please select another one',
  selectOutputOne: 'Please select a output at least.',
  downloadHome: 'Download on TVU Home',
  notShow: 'Don’t Show Again',
  Original: 'Original',
  After: 'After',
  yuvC: 'YUV Control',
  rgbC: 'RGB Control',
  autoC: 'Auto White Balance',
  yGain: 'Y Gain',
  chroma: 'Chroma',
  hue: 'Hue',
  yOffset: 'Y Offset',
  gamma: 'Gamma',
  reset: 'Reset',
  resetAll: 'Reset All',
  vector: 'Vector Scope',
  waveform: 'RGB Parade',
  rGain: 'R Gain',
  rOffset: 'R',
  gGain: 'G Gain',
  gOffset: 'G',
  bGain: 'B Gain',
  bOffset: 'B',
  uploadRP: 'Upload a reference picture',
  uploadS: 'Upload Successfully',
  uploadE: 'Failed to upload file',
  uploading: 'uploading',
  preUpload: 'Preparing to upload',
  available: 'Available',
  occupied: 'Occupied',
  ratio: 'Aspect Ratio',
  uhdTip: "UHD sources require additional resources to decode.Enable if the Input Source's resolution is higher than 1920x1080",
  spearkerTip: 'Record Audio Only from the Selected User',
  isolatedAudio: 'Isolated Audio',
  noPermissonRemoveObj: "You don't have permission to remove the assignment of this device from this object.",
  removeAssign: 'Are you sure you want to remove the assignment of this device from this object?',
  selectSourceType: 'Select Source Type',
  modifySourceType: 'Please stop preview or live first if modify the source type.',
  unlinkSourceType: 'Please stop preview or live first if remove the assignment of this device from this object',
  assignSourceType: 'Please stop preview or live first if modify the assignment of this device from this object',
  selectFileCom: 'Select file from your computer',
  selectAll: 'Select All',
  selectSDIPort: 'Select SDI Port',
  noSDIDeviceDetected: 'No SDI Device Detected',
  QR: 'QR code',
  QRToken: 'Copy Token',
  QRCode: 'Copy QR Code',
  QRScan: 'Scan the QR code by TVU Anywhere',
  anywhere1: "1. Install 'TVU Anywhere' on your device",
  anywhere2: "2. Open the 'TVU Anywhere' app",
  anywhere3: "3. Select 'Scan' to scan or upload this QR code",
  anywhere4: '4. Your TVU Anywhere device will appear in the',
  anywhere5: "'Available' device list",
  addTVUDevice: 'Add TVU Anywhere Device',
  openMP: 'Are you sure to open the Manage Payment portal?',
  manageSub: 'Manage Subscriptions',
  domain: 'Domain Name',
  enterDomain: 'Enter Domain Name',
  key: 'Key',
  enterKey: 'Enter Key',
  enterMeeting: 'Enter Meeting ID',
  enterDN: 'Enter Domain Name',
  domianName: 'Domain Name',
  switchLiveT: 'This project is live with <span style="color: #E56464;">{sourceObjectName}</span>.</br>Are you sure you want to use <span style="color: #E56464;">{objectName}</span>?',
  switchLiveF: 'This folder is live with <span style="color: #E56464;">{sourceObjectName}</span>.</br>Are you sure you want to use <span style="color: #E56464;">{objectName}</span>?',
  vaildDomain: 'Please enter the valid domain',
  portTips: 'Please enter the number of port',
  eventNameTip: 'Please enter the Event name',
  participantName: 'Participant Name',
  enterTips: 'Please enter the {type}',
  switcher: 'The current switcher is starting, Please wait',
  NDIName: 'NDI-HOST-MACHINE-NAME',
  NDISourceName: 'NDI-Stream-Name',
  joinZoom: 'Join Zoom Meeting',
  passcode: 'Passcode',
  publicIp: 'Currently showing Public IP Address',
  privateIp: 'Currently showing Local IP Address',
  ipBasedUrl: 'IP based URL:',
  baseUrlTip1: 'If your DNS cannot resolve the domain name, use this',
  baseUrlTip2: 'IP address URL instead. Note that the IP address will',
  baseUrlTip3: 'change each time the task restarts',
  srtUrl: 'Enter SRT Caller URL',
  rtspUrl: 'Enter RTSP Entrypoint URL',
  rtmpUrl: 'Enter RTMP Entrypoint URL',
  frameConversion: 'Motion Compensated Frame Rate Conversion',
  frameConversionTips: 'Enhances video fluidity by converting frame rates using advanced motion estimation. <br/>Note: This is a paid feature due to intensive computational requirements.',
  disabledFrameConversion: 'Motion Compensated Frame Rate Conversion is not supported for Follow Input outputs.',
  disabledColorCorrection: 'Color Correction is not supported for Follow Input outputs.',
  enableColorCorrection: 'You must enable the Color Correction feature in the Source Configuration Page.',
  applyColorCorrection: 'You must start decoding the video first before you can apply Color Correction.',
  message: 'Message',
  paidFeature: 'This is a Paid Feature. Please Contact TVU Support.',
  Sorting: 'Sorting',
  enterProjectName: 'Enter Project Name',
  copyright: 'Copyright',
  terms: 'Terms & Conditions',
  policy: 'Privacy Policy',
  license: 'Content Licence',
  startLiveOccupied: '{desName} is occupied by project {prjName}',
  destCount: 'Destination Count',
  passthroughTips: 'All encoding profile of destinations in this project would follow project if enable Follow Input when live.',
  microTip: 'Will Take Effect after restart',
  microMsTip: 'The set milliseconds are not available',
  projectConfig: 'Project Configuration',
  microservice: 'Microservice',
  settings: 'Settings',
  basicInfo: 'Name & Tags',
  streamConfig: 'Stream Config',
  resources: 'Resources',
  continue: 'Continue',
  autoPreview: 'Auto Preview',
  graphics: 'Graphics',
  srtLatencyNote: 'If your URL includes latency parameter, make sure it is specified in microseconds (μs)',
  switchForBlack: 'Switch backup source when detect black frame',
  disasterRecovery: 'Disaster Recovery',
  selectbackup: 'Select Backup Source',
  ignoreInitialTransmission: 'Ignore Initial Transmission',
  ignoreInitialTransmissionTip: 'Decode errors during the first few seconds of a new stream are normal. This setting prevents false failovers during source initialisation.',
  cooldownPeriod: 'Cooldown Period',
  cooldownPeriodTip: 'Minimum time between automatic switches',
  lowBitrateThreshold: 'Low Bitrate Threshold (Mbps)',
  lowBitrateThresholdTip: 'The minimum acceptable bitrate for the active source. If the incoming bitrate drops below this value, the system will begin monitoring for a potential switch to the backup source.',
  lowBitrateSwitchDelay: 'Low Bitrate Switch Delay',
  lowBitrateSwitchDelayTip: 'The number of consecutive seconds the bitrate must remain below the threshold before the system automatically switches to the backup source.',
  recoveryDuration: 'Recovery Duration',
  recoveryDurationTip: 'How long bitrate must stay above threshold before switching back to primary',
  seconds: 'seconds',
  blackFrameDetection: 'Black Frame Detection',
  detectionMode: 'Detection Mode',
  bitrateMode: 'Bitrate Mode',
  blackFrameMode: 'Black Frame Mode',
  manualOnlyMode: 'Manual Only',
  manualOnlyTip: 'Manual only. Nothing is monitored.',
  blackFrameSeamlessTip: 'To use black-frame-based auto switching, enable Seamless Switching on the target destination.',
  autoFailover: 'Auto Failover',
  emailNotify: 'Email Notification',
  comingSoon: 'coming soon...',
  detectBlackToBackPreText: 'Switch to backup source upon detecting',
  detectBlackToBackAftText: 'ms of black frames.',
  autoRecovery: 'Auto Recovery',
  detectBlackPreText: 'Switch to backup source upon detecting',
  detectBlackAftText: 'ms of black frames.',
  detectBlackToMainPreText: 'Switch back to primary source upon no more black frames after',
  detectBlackToMainAftText: 'ms.',
  // 容灾保存前置校验提示文案（validateDisaster 六条规则） [Claude Code]
  bfRequireFailoverOrEmail: 'In Black Frame Mode, enable at least one of Auto Failover or Email Notification',
  brRequireFailoverOrEmail: 'In Bitrate Mode, enable at least one of Auto Failover or Email Notification',
  bfFailoverDurationRequired: 'Black frame duration is required in Black Frame Mode',
  bfRecoveryDurationRequired: 'Recovery duration is required when Auto Recovery is enabled',
  bfEmailRequired: 'Select at least one email when Email Notification is enabled',
  drBackupSourceRequired: 'Select a backup source when Disaster Recovery is enabled',
  selectEmail: 'Select Email',
  tvuPick: 'Let TVU Pick for Me',
  selfPick: 'Pick Myself',
  tvuPickTip: 'TVU will automatically choose the best available region to ensure your task starts promptly.',
  selfPickTip: 'For advanced users who prefer to manually select their desired regions.',
  staticIp: 'Static IP',
  Total: 'Total',
  restartEffect: 'Changes will take effect after restart.',
  projectDestNum: 'Amount of Destinations Contained in the Project',
  otherDetail: 'Other Details',
  liveWithDest: 'Live with {destNum} Destination',
  output: 'Output',
  Transitioning: 'Transitioning',
  restoreConfig: 'Restore Last Config',
  destinationIdOrName: 'DestinationID or Name',
  stopProject: 'Are you sure you want to deactivate this Output Project?',
  stopProjectWithName: 'Are you sure you want to deactivate {objectName} Output Project?',
  stopFolderWithName: 'Are you sure you want to stop folder {objectName}?', // folder 顶层 stop 弹窗（MH-2633）[Claude Code]
  stopDestWithName: 'Are you sure you want to stop destination {objectName}?', // destination 顶层 stop 弹窗（MH-2633）[Claude Code]
  switchLiveD: 'This destination is live with <span style="color: #E56464;">{sourceObjectName}</span>.</br>Are you sure you want to use <span style="color: #E56464;">{objectName}</span>?',
  switchFolderLiveD: 'Folder <span style="color: #E56464;">{folderName}</span> is live with <span style="color: #E56464;">{currentSourceName}</span>.</br>Are you sure you want to switch to <span style="color: #E56464;">{newSourceName}</span>?',
  projectConfigs: 'Project Configuration',
  previewing: 'Previewing (Active Input + Preview)',
  ingesting: 'Receiving (Active Input)',
  ingesting1: 'Receive',
  ingesting2: 'Receiving',
  previewUsedBy: 'Preview used by {email} at {time}(UTC)',
  receiveUsedBy: 'Receive used by {email} at {time}(UTC)',
  liveUsedBy: 'Live used by {email} at {time}(UTC)',
  outputPreview: 'Auto-Start Preview When Take Live',
  noLiveD: 'No live destination',
  liveD: 'Live on {count} destinations',
  Previewing: 'Previewing',
  Ingesting: 'Receiving',
  Standby: 'Standby',
  noStopIngesting: 'Source is on live, you can’t stop ingesting.',
  keepIngesting: 'This source object is currently in use by an active output. <br/>Please stop the output before stopping the input.',
  sdiTipsRef: 'Ref Ports cannot be utilized for SDI signal transmission',
  sourceSearchP: 'Source Name/PID',
  projectSearchP: 'ProjectID or Name',
  destinationSearchP: 'Destination/Folder Name',
  otherSetting: 'Other Settings',
  stopLive: 'Stop Live',
  smpteTip: ` SMPTE ST 2022-7 a standard defining seamless<br>
              protection switching of RTP datagrams.It enables a<br>
              transmitter to send two identical packet streams over<br>
              redundant network paths,allowing the receiver to<br>
              reconstruct a single,uninterrupted output stream on a<br>
              packet-by-packet basis-even if one path fails
              <a href="https://www.smpte.org/?utm_source=chatgpt.com"
                 target="_blank"> more</a><br>
              <br>
              Usage Requirement:<br>
              A source with 2022-7 enabled can only be routed to a<br>
              2022-7 enabled destination.<br>`,
  createByMe: 'Created By Me',
  selfHost: 'Self-Hosted',
  autoShutIdle: 'Auto-shutdown idle input',
  autoShutIdleText: 'If an input source stays active for 15 minutes or more without going live, it will be stopped automatically.',
  stopNoNeed: 'Stop input when no longer needed',
  stopNoNeedText: 'When the last output source that depends on this input source stops, the input source will stop too.',
  audioSyncLicense: 'Audience Measurement Watermarking License',
  audioSyncLicenseTip: 'When Audience Measurement Watermarking is enabled on a destination, the license must be configured.',
  tvuHostedServerLocation: 'TVU Hosted Server Location',
  goMA: 'Go to Media Analyzer',
  noAccessWF: 'User does not have access to {wf} service.',
  workflowMonitor: 'MediaMesh Monitor',
  generateInfo: 'Generate and copy troubleshooting info for TVU Support',
  batchSelect: 'Batch Select',
  batchExit: 'Exit',
  nSelected: '{n} Selected',
  createFolder: 'Create Folder',
  hdmiSdiWarning: 'HDMI Ports cannot be utilized for SDI signal transmission', // SDI HDMI 端口警告 [Claude Code]
  ultraStudioSdiWarning: 'UltraStudio Monitor 3G does not support SDI Input', // UltraStudio SDI 输入警告 [Claude Code]
  interact: 'Interact', // HTML Source 交互按钮 [Claude Code]
  interactTip: '(You can use this feature after turn on source preview)', // 交互功能提示 [Claude Code]
  ndiDiscoveryBy: 'Discovery by', // NDI 发现方式列标题 [Claude Code]
  audioOnly: 'Audio Only', // 仅音频开关标签 [Claude Code]
  mxlInputVideoUuid: 'UUID of MXL Input Video Shared Memory', // MXL 视频共享内存 UUID 标签 [Claude Code]
  mxlInputAudioUuid: 'UUID of MXL Input Audio Shared Memory', // MXL 音频共享内存 UUID 标签 [Claude Code]
  mxlVideoDomainPath: 'Path of MXL Video Shared Memory Domain', // MXL 视频共享内存域路径标签 [Claude Code]
  mxlAudioDomainPath: 'Path of MXL Audio Shared Memory Domain', // MXL 音频共享内存域路径标签 [Claude Code]
  enterContent: 'Enter Content', // 通用输入占位符 [Claude Code]
  pleaseEnterContent: 'Please enter content', // 表单校验提示 [Claude Code]
  errorMonitor: 'Error Monitor', // 错误监控标题 [Claude Code]
  operationalLogs: 'Operational Logs', // 操作日志标题 [Claude Code]
  errors: 'errors', // 错误数徽章 [Claude Code]
  warnings: 'warnings', // 警告数徽章 [Claude Code]
  enterScheduleName: 'Enter schedule name', // 排程名称输入占位符 [Claude Code]
  time: 'Time', // 时间标签 [Claude Code]
  noSourceSelected: 'No source selected', // 未选择源占位文本 [Claude Code]
  browse: 'Browse', // 浏览按钮 [Claude Code]
  noDestSelected: 'No destination selected', // 未选择目标占位文本 [Claude Code]
  addDescription: 'Add description', // 添加描述占位符 [Claude Code]
  selectSource: 'Select Source', // 选择源弹窗标题 [Claude Code]
  selectDestination: 'Select Destination', // 选择目标弹窗标题 [Claude Code]
  editSchedule: 'Edit Schedule', // 编辑排程弹窗标题 [Claude Code]
  addSchedule: 'Add Schedule', // 新增排程弹窗标题 [Claude Code]
  scheduleDeletedSuccess: 'Schedule deleted successfully', // 排程删除成功 [Claude Code]
  scheduleDeleteFailed: 'Failed to delete schedule', // 排程删除失败 [Claude Code]
  scheduleUpdatedSuccess: 'Schedule updated successfully', // 排程更新成功 [Claude Code]
  scheduleCreatedSuccess: 'Schedule created successfully', // 排程创建成功 [Claude Code]
  scheduleSaveFailed: 'Failed to save schedule', // 排程保存失败 [Claude Code]
  scheduleCreateFailed: 'Failed to create schedule', // 排程创建失败 [Claude Code]
  success: 'Success', // 成功通知标题 [Claude Code]
  error: 'Error', // 错误通知标题 [Claude Code]
  today: 'Today', // 今天按钮 [Claude Code]
  noScheduledRoutes: 'No scheduled routes yet.', // 无排程路由提示 [Claude Code]
  scheduleRoute: 'Schedule Route', // 排程路由按钮 [Claude Code]
  scheduleARoute: 'Schedule a route', // 排程一条路由按钮 [Claude Code]
  download: 'Download', // 下载按钮 [Claude Code]
  gotIt: 'Got It', // 知道了按钮 [Claude Code]
  noResultsFound: 'No results found', // 未找到结果 [Claude Code]
  folder: 'Folder', // 文件夹标签 [Claude Code]
  added: 'Added', // 已添加标签 [Claude Code]
  allLoaded: 'All loaded', // 已全部加载提示 [Claude Code]
  Sun: 'Sun', // 星期日缩写 [Claude Code]
  Mon: 'Mon', // 星期一缩写 [Claude Code]
  Tue: 'Tue', // 星期二缩写 [Claude Code]
  Wed: 'Wed', // 星期三缩写 [Claude Code]
  Thu: 'Thu', // 星期四缩写 [Claude Code]
  Fri: 'Fri', // 星期五缩写 [Claude Code]
  Sat: 'Sat', // 星期六缩写 [Claude Code]
  doesNotRepeat: 'Does not repeat', // 不重复选项 [Claude Code]
  everyWeekday: 'Every weekday (Mon–Fri)', // 每个工作日选项 [Claude Code]
  Day: 'Day', // 日视图 [Claude Code]
  Week: 'Week', // 周视图 [Claude Code]
  Month: 'Month', // 月视图 [Claude Code]
  sourceUrlName: 'Source URL/Name', // 源URL/名称列头 [Claude Code]
  severity: 'Severity', // 严重程度列头 [Claude Code]
  searchByEmail: 'Search by email', // 按邮箱搜索占位符 [Claude Code]
  end: 'End', // 日期范围结束占位符 [Claude Code]
  object: 'Object', // 对象列头 [Claude Code]
  errorType: 'Error Type', // 错误类型列头 [Claude Code]
  timestamp: 'Timestamp', // 时间戳列头 [Claude Code]
  loadingText: 'Loading...', // 加载中提示 [Claude Code]
  operated: 'operated', // 操作了 [Claude Code]
  noMoreData: 'No More Data', // 没有更多数据提示 [Claude Code]
  noErrorLogsFound: 'No error logs found', // 未找到错误日志提示 [Claude Code]
  noPermissionDeleteTags: 'You do not have permission to delete the tags.', // 无权删除标签提示 [Claude Code]
  feedbackToTvu: 'Feedback to TVU Mediahub', // 问题反馈弹窗标题 [Claude Code]
  title: 'Title', // 标题表单标签 [Claude Code]
  enterTitle: 'Enter title', // 输入标题占位符 [Claude Code]
  enterDescription: 'Enter Description', // 输入描述占位符 [Claude Code]
  create: 'Create', // 创建按钮 [Claude Code]
  folderName: 'Folder Name', // 文件夹名称 [Claude Code]
  enterFolderName: 'Enter Folder Name', // 输入文件夹名称占位符 [Claude Code]
  addDestination: 'Add Destination', // 添加目标 [Claude Code]
  updateFolderSuccess: 'Update Folder Successfully', // 更新文件夹成功 [Claude Code]
  successCreateFolder: 'Object created<br/><a id="view-project-object-click">View Object</a>', // 创建文件夹成功，含查看链接 [Claude Code]
  failedCreateFolder: 'Object created failed', // 创建文件夹失败 [Claude Code]
  failedBindDestinations: 'Failed to bind destinations to folder', // 绑定目标到文件夹失败 [Claude Code]
  // MH-2728 REQ-05：Folder 弹窗 destination 列表表头改为首字母大写 [Claude Code]
  colDestination: 'Destination', // 表头：目标 [Claude Code]
  colStatus: 'Status', // 表头：状态 [Claude Code]
  colSource: 'Source', // 表头：源 [Claude Code]
  colAction: 'Action', // 表头：操作 [Claude Code]
  errorRate8s: 'Error Rate(8s):', // 8秒错误率 [Claude Code]
  errorRate1s: 'Error Rate(1s):', // 1秒错误率 [Claude Code]
  lineQuality8s: 'Line Quality(8s):', // 8秒线路质量 [Claude Code]
  lineQuality1s: 'Line Quality(1s):', // 1秒线路质量 [Claude Code]
  videoInput: 'Video Input:', // 视频输入 [Claude Code]
  inputFormat: 'Input Format:', // 输入格式 [Claude Code]
  delayS: 'Delay (s)', // 延迟（秒）[Claude Code]
  bitrateMbps: 'Bitrate (Mbps)', // 码率（Mbps）[Claude Code]
  defaultBtn: 'Default', // 默认按钮 [Claude Code]
  resetToLast: 'Reset to Last', // 恢复上次按钮 [Claude Code]
  applySuccess: 'Apply successfully', // 应用成功 [Claude Code]
  primarySetting: 'Primary Setting', // 主路设置 [Claude Code]
  secondarySetting: 'Secondary Setting', // 备路设置 [Claude Code]
  labelNic: 'NIC', // 网卡标签 [Claude Code]
  labelSourceBroadcastIp: 'Source Broadcast IP', // 源广播IP标签 [Claude Code]
  labelSourceBroadcastPort: 'Source Broadcast Port', // 源广播端口标签 [Claude Code]
  labelSourceIp: 'Source IP', // 源IP标签 [Claude Code]
  allLevels: 'All Levels', // 所有级别 [Claude Code]
  objectInactive: 'Object Inactive', // 对象未激活 [Claude Code]
  domainNamePlaceholder: 'Domain Name', // 域名占位符 [Claude Code]
  streamKeyPlaceholder: 'Stream Key', // 推流密钥占位符 [Claude Code]
  none: 'None', // 无 [Claude Code]
  srtConnectionStatus: 'Srt Connection Status:', // SRT连接状态 [Claude Code]
  Waiting: 'Waiting', // SRT 状态：等待 [Claude Code]
  Sending: 'Sending', // SRT 状态：推流中 [Claude Code]
  Accepted: 'Accepted', // SRT 状态：已接受 [Claude Code]
  Rejected: 'Rejected', // SRT 状态：已拒绝 [Claude Code]
  Closed: 'Stopped', // SRT 状态：已停止（Other tooltip 子段标题，i18n 值改 Stopped 但 key 名保留 Closed 对齐 SRT 协议 CLOSED 桶）[Claude Code]
  Other: 'Other', // SRT 状态聚合 pill 标签：Closed + Rejected [Claude Code]
  sendingSinceLine: 'Sending to {target} since {time}', // SRT Sending tooltip 行描述：target=ip:port，time=YYYY-MM-DD HH:mm:ss [Claude Code]
  stoppedSendingSinceLine: 'Stopped sending to {target} since {time}', // SRT Closed tooltip 行描述 [Claude Code]
  rejectedAtLine: 'Rejected {target} at {time}', // SRT Rejected tooltip 行描述 [Claude Code]
  recentActivity: 'Recent Activity', // 状态 tooltip 表头 [Claude Code]
  waitingForCaller: 'Waiting for a caller to connect', // SRT Listener waiting 提示 [Claude Code]
  waitingToListener: 'Waiting to connect to the listener', // SRT Caller waiting 提示 [Claude Code]
  operationLog: 'Operation Log', // 状态 tooltip 操作日志链接 [Claude Code]
  addEvent: 'Add Event', // 添加日程标题 [Claude Code]
  editRecurringEvent: 'Recurring event', // 编辑重复日程标题 [Claude Code]
  deleteRecurringEvent: 'Delete recurring event', // 删除重复日程标题 [Claude Code]
  deleteEvent: 'Delete Event', // 删除日程标题 [Claude Code]
  thisEvent: 'This event', // 此日程单选项 [Claude Code]
  thisAndFollowingEvents: 'This and following events', // 此日程及后续日程单选项 [Claude Code]
  allEvents: 'All Events', // 所有日程单选项 [Claude Code]
  endDate: 'End Date', // 结束日期 placeholder [Claude Code]
  alwaysOn: 'Always on', // 永久启用 schedule（form 勾选 + pill 状态）[Claude Code]
  endsAt: 'Ends {time}', // pill 上"Ends 6:30pm" 的可翻译模板，大小写对齐 Figma 1477-3340 [Claude Code]
  endTimeMustBeLaterThanStart: 'End time must be later than start time', // 时段非法提示 [Claude Code]
  deleteEventConfirm: 'Are you sure you want to delete this event?', // 删除日程确认提示 [Claude Code]
  setDefaultSettingConfirm: 'Do you want to set this access configuration as the default setting?', // 设为默认配置确认提示 [Claude Code]
  dontRemindNextTime: "Don't remind me next time.", // 下次不再提醒 [Claude Code]
  customRecurrence: 'Custom Recurrence', // 自定义重复标题 [Claude Code]
  repeatEvery: 'Repeat every', // 重复频率标签 [Claude Code]
  repeatOn: 'Repeat On', // 重复日期标签 [Claude Code]
  ends: 'Ends', // 结束标签 [Claude Code]
  never: 'Never', // 永不单选项 [Claude Code]
  onLabel: 'On', // 指定日期单选项 [Claude Code]
  afterLabel: 'After', // 指定次数单选项 [Claude Code]
  occurrences: 'occurrences', // 次数单位 [Claude Code]
  customDots: 'Custom...', // 自定义（带省略号）选项 [Claude Code]
  Year: 'Year', // 年单位 [Claude Code]
  monthlyCustomOne: 'Monthly Custom one', // 月重复选项一 [Claude Code]
  monthlyCustomTwo: 'Monthly Custom two', // 月重复选项二 [Claude Code]
  idle: 'Idle', // 空闲状态 [Claude Code]
  clickToRouteHere: 'Click to route here', // 路由点击提示 [Claude Code]
  passthroughNoEffect: 'Wouldn\'t take effect on Follow Input destination.', // 直通目标不生效提示 [Claude Code]
  alreadyRouted: 'Already routed', // 已路由标题 [Claude Code]
  alreadyRoutedMsg: '{source} is already routed to {dest}', // 已路由提示信息 [Claude Code]
  viewMode: 'View Mode', // 视图模式标题 [Claude Code]
  viewModeCard: 'Card', // 卡片视图模式 [Claude Code]
  viewModeCompact: 'Compact', // 紧凑视图模式 [Claude Code]
  viewModeList: 'List', // 列表视图模式 [Claude Code]
  viewModeXYGrid: 'XY Grid', // XY Grid 视图模式 [Claude Code]
  selectDestinationFor: 'Select destination for "{name}"', // 为指定源选择目标 [Claude Code]
  selectDestinationTo: 'Select destination to "{name}"', // 选择目标到指定文件夹 [Claude Code]
  exitFilter: 'Exit Filter', // 退出筛选按钮 [Claude Code]
  showingConnectedDestinations: 'Showing {total} connected destinations', // 显示已连接的目标数量 [Claude Code]
  showingConnectedSources: 'Showing {total} connected sources', // 显示已连接的源数量 [Claude Code]
  refresh: 'Refresh', // 刷新按钮 [Claude Code]
  destinations: 'Destinations', // 目标列表标题 [Claude Code]
  startLive: 'Start', // 开始推流按钮 [Claude Code]
  noDestInFolder: 'No destinations in this folder', // 文件夹无目标空状态 [Claude Code]
  deleteFolder: 'Delete Folder', // 删除文件夹标题 [Claude Code]
  deleteFolderConfirm: 'Are you sure you want to delete this folder? <br/>Destinations inside will not be deleted.', // 删除文件夹确认 [Claude Code]
  apiLogTitle: 'API Log', // API 日志页标题 [Claude Code]
  apiLogTotal: '{count} requests', // 请求总数 [Claude Code]
  apiLogRefresh: 'Refresh', // 刷新按钮 [Claude Code]
  apiLogExport: 'Export CSV', // 导出按钮 [Claude Code]
  apiLogClear: 'Clear', // 清空按钮 [Claude Code]
  apiLogPath: 'Path', // 接口路径列 [Claude Code]
  apiLogStatus: 'Status', // 状态码列 [Claude Code]
  apiLogStartTime: 'Start Time', // 开始时间列 [Claude Code]
  apiLogEndTime: 'End Time', // 结束时间列 [Claude Code]
  apiLogDuration: 'Duration(ms)', // 耗时列 [Claude Code]
  apiLogResult: 'Result', // 结果列 [Claude Code]
  apiLogEmpty: 'No requests recorded yet. Please interact with the page to generate requests.', // 空状态提示 [Claude Code]
  apiLogNoData: 'No data to export', // 无数据导出提示 [Claude Code]
  apiLogSlowOnly: 'Slow only (>1s)' // 慢接口筛选 [Claude Code]
}
